import {useQuery} from '@tanstack/react-query'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {useContentstackRMS} from '../../../context/contentstack'
import {getEntriesByIds} from '../../../custom-api/api/contentstack/sdk/entry'

export const useGetRecipeDetails = (recipe_id = [], contentTypeUid = '') => {
    const {locale} = useMultiSite()
    const {stack} = useContentstackRMS()

    const ids = Array.isArray(recipe_id) ? recipe_id : [recipe_id].filter(Boolean)
    return useQuery({
        queryKey: ['recipeDetailsQuery', ids],
        queryFn: async () => {
            if (ids.length === 0 || contentTypeUid === '') return []
            const response = await getEntriesByIds({
                stack,
                contentTypeUid,
                locale: locale?.alias,
                uids: ids,
            })
            return response
        },
    })
}
